module.exports = __webpack_public_path__ + "img/DigitalSinglePage.7004edfe.jpg";